module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes--6--b-f9ce208a.png";